
class Filter {
    constructor(args = {}) {
        this.el = args.el;

        this.el.addEventListener('change', (e) => {
            this.onChange(e);
            this.el.submit();
        });
    }

    getBranchName() {
        const branchBtn = document.querySelector('.branch__open');
        if (!branchBtn) return
        let branchName = branchBtn.innerText
        return branchName === 'VÄLJ BRANSCH' ? null : branchName.toLowerCase()
    }

    onChange(e) {
        var filter = '';
        if (e.target.name === '_branch') {
            filter = 'Branch';
        } else if (e.target.name === 'topic') {
            filter = 'Topic';
        }
        if (document.querySelector("body").classList.contains("issueswearepushingproxy")) {
            dataLayer.push({
                'event': 'IssuesWeArePushing',
                'filterTypIssuesWeArePushing': filter,   // filter man interagerar med dvs "Branch" eller "Topic".
                'filterIssuesWeArePushing': e.target.options[e.target.selectedIndex].text,
                'isAuthenticated': window.authenticated,
                'selectedBranch': this.getBranchName()
            });
        }
    }
}


window.addEventListener('DOMContentLoaded', () => {
    const filter = document.querySelector('.filter');
    if (filter) {
        new Filter({ el: filter });
    }
});